import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/financial/invoicesReportActions'
import { DatePicker, Button, Form, Checkbox, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/financial/invoices-report/ListItems'
import moment from 'moment'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config
const { RangePicker } = DatePicker

const propTypes = {}
const FormItem = Form.Item
const CheckboxGroup = Checkbox.Group

class InvoicesReportContainer extends Component {
  constructor(props) {
    super(props)

    const filter = [
      moment(new Date(), 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]

    this.state = {
      filter,
      checkedList: [],
      checkAll: false,
      plainOptions: ['Paid', 'Created', 'Resubmitted', 'Sent', 'Rejected']
    }

    // get job list
    this.props.invoicesReportGetJobList({})
    // get organization list
    this.props.invoicesReportGetOrganizationList({})
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  onChangeCheckboxGroup = checkedList => {
    this.setState({
      checkedList,
      checkAll: checkedList.length === this.state.plainOptions.length
    })
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.invoicesReportGetFullReport({ filters: values })
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.invoicesReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  handleOrganizationSearch = _.debounce(value => {
    this.props.invoicesReportGetOrganizationList({
      filters: {
        name: value
      }
    })
  }, 500)

  onCheckAllChange = e => {
    const { form } = this.props

    form.setFieldsValue({
      statuses: e.target.checked ? this.state.plainOptions : []
    })

    this.setState({
      checkedList: e.target.checked ? this.state.plainOptions : [],
      checkAll: e.target.checked
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      if (values.date_range[0] && values.date_range[1]) {
        params.startDate = moment(values.date_range[0]).format('YYYY-MM-DD')
        params.endDate = moment(values.date_range[1]).format('YYYY-MM-DD')
      }

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/financial/invoices-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'invoicesReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'invoicesReportActions.loadingJobList')

    const organizationListData = _.get(this.props, 'invoicesReportActions.organizationList.data')
    const loadingOrganizationList = _.get(
      this.props,
      'invoicesReportActions.loadingOrganizationList'
    )

    const loadingFullReport = _.get(this.props, 'invoicesReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'invoicesReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Invoices</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-6">
                  <FormItem label="Select the date range:">
                    {getFieldDecorator('date_range', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a value'
                        }
                      ],
                      initialValue: this.state.filter
                    })(<RangePicker onChange={this.onChange} />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      {getFieldDecorator('job_id', {})(
                        <AutoComplete
                          onChange={this.handleJobSearch}
                          dataSource={convertToOption(jobListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Job"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingOrganizationList}>
                    <FormItem label="Company">
                      {getFieldDecorator('company_id', {})(
                        <AutoComplete
                          onChange={this.handleOrganizationSearch}
                          dataSource={convertToOption(organizationListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Company"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
            <div className="col-6">
              <FormItem label="Select statuses:">
                {getFieldDecorator('statuses', {
                  initialValue: this.state.checkedList
                })(
                  <CheckboxGroup
                    options={this.state.plainOptions}
                    onChange={this.onChangeCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox
                  indeterminate={this.state.indeterminate}
                  onChange={this.onCheckAllChange}
                  checked={this.state.checkAll}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ invoicesReportActions, authentication }, ownProps) => ({
  invoicesReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

InvoicesReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(InvoicesReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/financial/InvoicesReportContainer.js